import React from 'react';
import { Button, Box } from '@mui/material';
import { PlayArrow } from '@mui/icons-material';

const ContinueDiscoveryButton = ({ lastCompletedTopic, onContinue }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px',
        marginTop: '8px',
        marginBottom: '8px'
      }}
    >
      <Button
        variant="contained"
        color="primary"
        startIcon={<PlayArrow />}
        onClick={onContinue}
        sx={{
          backgroundColor: '#1976d2',
          '&:hover': {
            backgroundColor: '#1565c0',
          },
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '14px',
          fontWeight: 600,
          textTransform: 'none',
          boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
          }
        }}
      >
        Continue Discovery
      </Button>
    </Box>
  );
};

export default ContinueDiscoveryButton;
